export enum NEW_RETURNING_USER_TYPE {
  NEW = 'new',
  RETURNING = 'returning',
}
